import { useEffect } from "react";
import SiteNavbar from "@/components/feature/SiteNavbar";
import ContactsHero from "@/pages/contacts/components/ContactsHero";
import ContactMethods from "@/pages/contacts/components/ContactMethods";
import BookingForm from "@/pages/contacts/components/BookingForm";
import ContactsLocation from "@/pages/contacts/components/ContactsLocation";
import ContactsFAQ from "@/pages/contacts/components/ContactsFAQ";
import ContactsCTA from "@/pages/contacts/components/ContactsCTA";

/**
 * /contacts — Serene's Contacts page.
 *
 * Structure:
 *   1. Hero            — Big headline, subtitle, quick email/phone bar, warm image
 *   2. Contact Methods — 3 image cards (email / call / message)
 *   3. Booking Form    — Full multi-step form with honeypot + chip groups
 *   4. Location        — Google Maps embed + address, hours, getting-here
 *   5. FAQ             — Accordion of common questions
 *   6. CTA             — Closing "one message is the whole beginning"
 */
export default function Contacts() {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  return (
    <div className="relative w-full bg-background-50">
      <SiteNavbar />
      <ContactsHero />
      <ContactMethods />
      <BookingForm />
      <ContactsLocation />
      <ContactsFAQ />
      <ContactsCTA />
    </div>
  );
}